import { ApolloError } from "@apollo/client";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import OverrideAutoValidationForm from "../OverrideAutoValidationForm";

type Props = {
    isOverridden: boolean;
    overriddenReason?: string | null;
    onOverride: (reason: string) => Promise<void>;
    onRevert: () => void;
    loading: boolean;
    error?: ApolloError;
};

export default function OverrideAutoValidationSection({
    isOverridden,
    overriddenReason,
    onOverride,
    onRevert,
    loading,
    error,
}: Props) {
    const { t } = useTranslation("project");

    return (
        <Box paddingInline={2} paddingTop={2}>
            {isOverridden ? (
                <Stack rowGap={2}>
                    <Typography variant="caption">
                        {t("projectReviewVisitV2.overrideAutoValidation.reasonForApproval")}
                    </Typography>
                    <Typography>{overriddenReason}</Typography>
                    <Button onClick={onRevert} loading={loading} variant="outlined" color="error">
                        {t("projectReviewVisitV2.overrideAutoValidation.revertApprovalBtn")}
                    </Button>
                </Stack>
            ) : (
                <OverrideAutoValidationForm onOverride={onOverride} error={error} />
            )}
        </Box>
    );
}
